<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="修改产品"
      :innerHeight="120"
      :innerScroll="false"
      :qLoading="confirmLoading"
      width="600px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="form" size="small" :rules="rules" ref="ruleForm" label-width="100px" v-loading="loading">
        <div class="tips">仅支持对临时产品编码和临时产品名称进行修改</div>
        <el-form-item label="产品编码" prop="productCode">
          <el-input v-model.trim="form.productCode" class="form-input" />
        </el-form-item>
        <el-form-item label="产品名称" prop="productName">
          <el-input v-model.trim="form.productName" class="form-input" />
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: {
    visible: Boolean,
    productData: Object,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        productCode: '',
        productName: '',
      },
      rules: {
        productCode: [{ required: true, message: '产品编码不能为空', trigger: 'blur' }],
        productName: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
      },
      loading: false,
      confirmLoading: false,
    };
  },
  created() {
    this.init();
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$emit('input', false);
      }, 200);
    },
    confirm() {
      this.confirmLoading = true;
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          this.confirmLoading = false;
          return;
        }
        const params = {
          ...this.form,
          oldProductCode: this.productData.productCode,
          oldProductName: this.productData.productName,
          spuId: this.productData.spuId,
          skuId: this.productData.skuId,
        };
        console.log('🚀 ~ params:', params);
        this.$q.newProduct
          .updateSpuProduct({ data: params })
          .then(({ success }) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '修改产品成功',
              });
              this.updateVal();
              this.$emit('success');
            }
          })
          .finally(() => {
            this.confirmLoading = false;
          });
      });
    },
    init() {
      this.dialogVisible = this.visible;
      if (this.productData) {
        this.form.productCode = this.productData.productCode || '';
        this.form.productName = this.productData.productName || '';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.tips
  color: #ff4d4f
  padding-bottom: 10px
  font-size: 14px

.form-input
  width: 100%
</style>
